import axios from "../config/axios";
import toast from "react-hot-toast";
import { CreatorApi } from "../Utils/Api";

export const SET_CREATOR = "SET_CREATOR";
export const CLEAR_CREATOR = "CLEAR_CREATOR";

export const setCreator = (creator, token) => ({
  type: SET_CREATOR,
  payload: { creator, token },
});

export const clearCreator = () => ({
  type: CLEAR_CREATOR,
});

export const loginWithGoogle = (tokenId) => async (dispatch) => {
  let isApiCallComplete = false;

  const firstToast = toast.loading("Please Wait ...", {
    position: "top-center",
    duration: 1500,
  });

  let secondToastId = null;

  const secondToastTimeout = setTimeout(() => {
    if (!isApiCallComplete) {
      toast.dismiss(firstToast);
      secondToastId = toast.loading("Please Refresh and try again ...", {
        position: "top-center",
      });
    }
  }, 1500);

  try {
    const response = await axios.post(CreatorApi.Login, {
      access_token: tokenId.access_token,
    });

    const { creator, token } = response.data;
    dispatch(setCreator(creator, token));

    isApiCallComplete = true;
    toast.dismiss(firstToast);
    clearTimeout(secondToastTimeout);

    if (secondToastId) toast.dismiss(secondToastId);

    toast.success("Login successful!", {
      position: "top-center",
    });
  } catch (error) {
    isApiCallComplete = true;
    const errorMessage = "Google login failed. Please try again.";

    toast.dismiss(firstToast);
    clearTimeout(secondToastTimeout);

    if (secondToastId) toast.dismiss(secondToastId);

    toast.error(errorMessage, {
      position: "top-center",
    });
  }
};

export const logout = () => (dispatch) => {
  dispatch(clearCreator());
  toast.success("Logged out successfully!");
};
